import { createSlice } from '@reduxjs/toolkit';
import { getInfluencer, getInfluencerById, getReferralHistory } from './actions';

const initialState = {
  list: [],
  byId: {},
  referralHistory: {},
  isLoading: false,
  historyLoading: false,
  isError: false,
  errorMessage: {},
};

export const influencer = createSlice({
  name: 'influencer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInfluencer.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.list = [];
      })
      .addCase(getInfluencer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getInfluencer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(getInfluencerById.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.byId = {};
      })
      .addCase(getInfluencerById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getInfluencerById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.byId = action.payload;
      })
      .addCase(getReferralHistory.pending, (state) => {
        state.historyLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.referralHistory = {};
      })
      .addCase(getReferralHistory.rejected, (state, action) => {
        state.historyLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getReferralHistory.fulfilled, (state, action) => {
        state.historyLoading = false;
        state.referralHistory = action.payload;
      });
  },
});

export default influencer.reducer;
